module.exports = __webpack_public_path__ + "static/media/thermomix_2x.9d669897.svg";